import React from 'react';
import styled from "styled-components";

// -----------------------------------

const FontWrapper = styled.div`
	border-bottom: 1px solid #617B7B;
	padding: 1em 0;
	display: inline-block;
`;

const FontName = styled.div`
	font-family: sans-serif;
	color: #617B7B;
`;

const FontDisplay = styled.div`
	font-weight: bold;
	font-size: 3em;
	font-family: "${ ({ font, }) => { return font } }", sans-serif;
	color: #FFFAE1;
	text-rendering: optimizeLegibility;
	display: inline-block;
`;

// -----------------------------------

export default ({ font, text, }) =>
	<FontWrapper>
		<FontName>{ font }</FontName>

		<FontDisplay font = { font } >{ text }</FontDisplay>
	</FontWrapper>


// WEBPACK FOOTER //
// ./src/components/font.js